import { api } from './api';

export interface AppConfig {
  googleMapsApiKey: string;
  maxPlayersPerRoom: number;
  locationsProblem: string | null;
  /** Locations are placeholders (no Google key): panoramas can't be shown. */
  demo: boolean;
  /** Starting a game needs the server's access code. */
  accessRequired: boolean;
}

let configPromise: Promise<AppConfig> | null = null;

async function fetchConfig(): Promise<AppConfig> {
  // Keep trying instead of failing: a server restart shouldn't crash a running game.
  for (let attempt = 0; ; attempt++) {
    try {
      return await api.get<AppConfig>('/api/config');
    } catch {
      await new Promise((resolve) => setTimeout(resolve, Math.min(5000, 500 * 2 ** attempt)));
    }
  }
}

/** Server-provided runtime configuration, fetched once per page load. Use with React's `use()`. */
export function appConfig(): Promise<AppConfig> {
  configPromise ??= fetchConfig();
  return configPromise;
}
